import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from '../Components/useIsMountedRef';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {Link as UrlLink} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

const defaultFilter = {
  idServiceCategory: '0',
  idPartner: '0',
  text: '',
  showExtendedInfo: false,
  showDeletedItems: false
};

export default function Services(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState(defaultFilter);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemOperation, setSelectedItemOperation] = useState(null);
  const [selectedItemWarning, setSelectedItemWarning] = useState(null);

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  useEffect(() => {
    setIsLoaded(false);
    ajax('getServices')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const handleSelectedItemChange = e => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  useEffect(() => {
    if (selectedItem === null || selectedItemOperation === null)
      return;

    var warning = null;
    switch (selectedItemOperation) {
      case 'editService':
        warning = warning === null ? selectedItem.service.length < 6 ? 'Numele serviciului este prea scurt' : null : warning;
        break;

      default:
        break;
    }

    setSelectedItemWarning(warning);
  }, [data, selectedItem, selectedItemOperation]);

  const filterData = item => true
      && (filter.idServiceCategory === '0' || item.idServiceCategory === filter.idServiceCategory)
      && (filter.idPartner === '0' || item.idPartner === filter.idPartner)
      && (
           !!~item.service.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.description.toLowerCase().indexOf(filter.text.toLowerCase())
      )
      && ((!filter.showDeletedItems && item.deletedBy === null) || (filter.showDeletedItems && item.deletedBy !== null));

  const handleItemMenuOpen = item => e => {
    setSelectedItem(item);
    setAnchorEl(e.currentTarget);
  };
  const handleItemMenuClick = operation => () => {
    setAnchorEl(null);
    setSelectedItemOperation(operation);
  };
  const handleItemMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
    setSelectedItemOperation(null);
  };

  const handleEditService = () => {
    setIsLoaded(false);
    ajax('saveService', selectedItem)
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleDeleteService = () => {
    setIsLoaded(false);
    ajax('markServiceAsDeleted', {
      idService: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleUndeleteService = () => {
    setIsLoaded(false);
    ajax('markServiceAsUndeleted', {
      idService: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Servicii si pachete de servicii</Typography>
      <Typography variant='subtitle2'>Administrare servicii si pachete de servicii.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.services.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.services.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4}>
            <TextField margin='none' select
              label='Categorie de servicii'
              placeholder='Categorie de servicii'
              name='idServiceCategory'
              value={filter.idServiceCategory}
              onChange={handleFilterChange}
            >
              <MenuItem key='0' value='0'>Toate categoriile de servicii</MenuItem>
              {data.serviceCategories.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.serviceCategory}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField margin='none' select
              label='Partener'
              placeholder='Partener'
              name='idPartner'
              value={filter.idPartner}
              onChange={handleFilterChange}
            >
              <MenuItem key='0' value='0'>Toti partenerii</MenuItem>
              {data.partners.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.partner}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showExtendedInfo'
                  checked={filter.showExtendedInfo}
                  value={filter.showExtendedInfo}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza informatii extinse'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showDeletedItems'
                  checked={filter.showDeletedItems}
                  value={filter.showDeletedItems}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza serviciile sterse'
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.services.length > 0 && data.services.filter(filterData).length === 0 &&
        <Box>
          <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
          <Typography color='primary' align='center'>Daca v-ati pierdut, incercati resetarea filtrelor de <UrlLink href='#' color='initial' onClick={() => setFilter(defaultFilter)}>aici</UrlLink></Typography>
        </Box>
      }

      {isLoaded &&
        <List dense>
          {data.services.filter(filterData).map((item, i, a) =>
            <Fragment key={item.id}>
              {(i === 0 || a[i].serviceCategory !== a[i - 1].serviceCategory) &&
                <ListSubheader color='primary' disableSticky>{item.serviceCategory}</ListSubheader>
              }

              <ListItem dense button className={classes.listItemDense}
                selected={selectedItem && item.id === selectedItem.id}
                onClick={() => {
                  setSelectedItem(item);
                  setSelectedItemOperation('editService');
                }}
              >
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography component='span' style={{fontWeight: 'bold'}}>
                      {item.isEnabled === '0' &&
                        <Typography display='inline' color='error' style={{fontWeight: 'bold'}}>[dezactivat] </Typography>
                      }
                      {item.service}
                      {item.year ? ` (doar pentru anul ${item.year})` : ''}
                    </Typography>
                  }
                  secondary={
                    <Box>
                      {item.isPurchasable === '0' &&
                        <Typography component='span' display='block' color='error' style={{fontWeight: 'bold'}}>
                          Nu se vinde ca si serviciu individual
                        </Typography>
                      }
                      <Typography component='span' display='block' color='textSecondary'>
                        Registru:
                        <Typography display='inline' color='textPrimary'>{` ${item.register}`}</Typography>
                      </Typography>
                      {filter.showExtendedInfo &&
                        <Box>
                          <Typography component='span' display='block' color='textSecondary'>
                            Specialitate:
                            <Typography display='inline' color='textPrimary'>{` ${item.specialty}`}</Typography>
                          </Typography>
                          <Typography component='span' display='block' color='textSecondary'>
                            Este pachet de servicii:
                            <Typography display='inline' color='textPrimary'>{` ${item.isServicePack === '1' ? 'DA' : 'NU'}`}</Typography>
                          </Typography>
                          <Typography component='span' display='block' color='textSecondary'>
                            Este serviciu importat din SmartLabs:
                            <Typography display='inline' color='textPrimary'>{` ${item.isSmartLabs === '1' ? 'DA' : 'NU'}`}</Typography>
                          </Typography>
                          <Typography color='textSecondary'>
                            {`Creat de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdBy}</Typography>
                            {` la data de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdAt}</Typography>
                          </Typography>
                        </Box>
                      }
                      {item.deletedBy &&
                        <Typography color='secondary'>{`Sters de ${item.deletedBy} la data de ${item.deletedAt}`}</Typography>
                      }
                      <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={handleItemMenuOpen(item)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      <Menu keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleItemMenuClose}
      >
        <MenuItem divider={false} onClick={handleItemMenuClick('editService')}>
          <ListItemIcon className={classes.listItemIcon}><EditIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1' style={{fontWeight: 'bold'}}>Modifica</Typography>
        </MenuItem>

        {selectedItem && !selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('deleteService')}>
            <ListItemIcon className={classes.listItemIcon}><DeleteIcon fontSize='small' color='secondary' /></ListItemIcon>
            <Typography variant='body1' color='secondary'>Sterge</Typography>
          </MenuItem>
        }

        {selectedItem && selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('undeleteService')}>
            <ListItemIcon className={classes.listItemIcon}><RestoreFromTrashIcon fontSize='small' color='primary' /></ListItemIcon>
            <Typography variant='body1' color='primary'>Anuleaza stergerea</Typography>
          </MenuItem>
        }
      </Menu>

      {isLoaded &&
        <Fab variant='extended' className={classes.fab}
          onClick={() => {
            setSelectedItem({
              id: '',
              idServiceCategory: '',
              idPartner: '',
              service: '',
              idSpecialty: '',
              isServicePack: '0',
              isPurchasable: '1',
              isEnabled: '1',
              idRegister: '',
              isSmartLabs: '0',
              description: ''
            });
            setSelectedItemOperation('editService');
          }}
        >
          <AddIcon className={classes.fabIcon} />
          Adauga serviciu
        </Fab>
      }

      {selectedItem && selectedItemOperation === 'editService' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'editService'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{selectedItem.name ? selectedItem.name : 'Adaugare serviciu nou'}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required select
                    label='Categorie de servicii'
                    placeholder='Categorie de servicii'
                    name='idServiceCategory'
                    value={selectedItem.idServiceCategory}
                    onChange={handleSelectedItemChange}
                  >
                    <MenuItem key='0' value='0'>Toate categoriile de servicii</MenuItem>
                    {data.serviceCategories.map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.serviceCategory}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required select
                    label='Partener'
                    placeholder='Partener'
                    name='idPartner'
                    value={selectedItem.idPartner}
                    onChange={handleSelectedItemChange}
                  >
                    <MenuItem key='0' value='0'>Toti partenerii</MenuItem>
                    {data.partners.map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.partner}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField margin='none' required autoComplete='off'
                    label='Nume serviciu'
                    placeholder='Nume serviciu'
                    name='service'
                    value={selectedItem.service}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='off'
                    label='Valabil pentru anul'
                    placeholder='Valabil pentru anul'
                    name='year'
                    value={selectedItem.year}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField margin='none' required autoComplete='off'
                    label='Ultimul numar alocat'
                    placeholder='Ultimul numar alocat'
                    name='lastNumber'
                    value={selectedItem.lastNumber}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField margin='none' multiline rows={3}
                    label='Observatii'
                    placeholder='Observatii'
                    name='description'
                    value={selectedItem.description}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleEditService}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'deleteService' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'deleteService'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Marcati acest serviciu ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti acest serviciu.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={handleDeleteService}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'undeleteService' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'undeleteService'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Anulati marcarea acestui serviciu ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe DA doar daca sunteti sigur ca doriti sa anulati stergerea acestui serviciu..</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleUndeleteService}>
              DA
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}